import { ModalFullscreen, IconClose16, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatModal.css';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

export interface IChatModalProps {
  isOpen: boolean;
  offer?: IDailyRentOfferForMobileSite;
  gaLabel?: string;
  onOpen?(): void;
  onClose(): void;
  dates: { checkin: string; checkout: string } | null;
  defaultMessage: string | null;
}

export function ChatModal({ isOpen, offer, onClose, onOpen, gaLabel, dates, defaultMessage }: IChatModalProps) {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  React.useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen, onOpen]);

  if (!offer) {
    return null;
  }

  const { cianId, dealType, offerType } = offer;

  /* istanbul ignore next */
  const src =
    `/dialogs/?hostType=frame&offerId=${cianId}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    '&pageType=Listing' +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    `${dates ? '&checkin=' + encodeURIComponent(dates.checkin) : ''}` +
    `${dates ? '&checkout=' + encodeURIComponent(dates.checkout) : ''}`;

  return (
    <ModalFullscreen onClose={onClose} open={isOpen} theme="white">
      <div className={styles['iframe-container']}>
        <span className={styles['close']} onClick={onClose}>
          <IconClose16 />
        </span>
        {isLoading && (
          <span className={styles['spinner']} data-testid="spinner">
            <Spinner size={16} />
          </span>
        )}
        <iframe data-name="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
      </div>
    </ModalFullscreen>
  );
}
